module.exports = __webpack_public_path__ + "static/media/RPFAnfrage.211ae50d.svg";